import VueScreenSize from "vue-screen-size";

const ScreenSizeMixin = {
  mixins: [
    VueScreenSize.VueScreenSizeMixin
  ],
  computed: {
    media() {
      return {
        sm: this.$vssWidth < 768,
        md: this.$vssWidth >= 768 && this.$vssWidth < 992,
        lg: this.$vssWidth >= 992 && this.$vssWidth < 1200,
        xl: this.$vssWidth >= 1200
      }
    },
    dialogWidth: function () {
      if (this.media.xl) {
        return '55%'
      } else if (this.media.lg) {
        return '65%'
      } else if (this.media.md) {
        return '75%'
      } else if(this.media.sm) {
        return '100%'
      }
      return '50%'
    }
  }
}

export default ScreenSizeMixin;
